import { render, staticRenderFns } from "./MedRecordUpdateValueDateType.vue?vue&type=template&id=2aabd474"
import script from "./MedRecordUpdateValueDateType.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdateValueDateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports